import React, { useRef } from 'react'
import { TabPanel } from 'primereact/tabview'
import { Card } from 'primereact/card'
import { useMountEffect } from 'primereact/hooks'
import { Messages } from 'primereact/messages'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { DashboardAlarmsWidget } from '../../../partner/components/dashboard-alarms-widget'
import {
    useUserGetFavouritesQuery,
    useStatisticsGetChargePointStatusStatsForAllQuery,
} from '../../../common/redux/api/web-api'
import { LatestErrorWidget } from '../../components/latest-error-widget'
import { ChargePointStatusDashboardWidget } from '../../../lib/charge-point-status-dashboard-widget'
import { ChargePointFavoritesDashboardWidget } from '../../../lib/charge-point-favorites-dashboard-widget'
import Text from '../../../ui/Text'
import { LazyTabView } from '../../../common/uikit/LazyTabView'
import useText from '../../../common/hooks/useText'

export const DashboardPage = () => {
    const { data: favourites } = useUserGetFavouritesQuery()
    const { data: statusStats } = useStatisticsGetChargePointStatusStatsForAllQuery()

    const text = useText()
    const msgs = useRef<Messages>(null)

    useMountEffect(() => {
        if (msgs.current) {
            msgs.current.clear()
            msgs.current.show([
                {
                    sticky: true,
                    severity: 'info',
                    detail: (
                        <Text
                            code="lblLMIIssueNotification"
                            values={{
                                link: {
                                    href: text('linkSupportHalo'),
                                    target: '_new',
                                },
                                link2: {
                                    href: text('linkSupportAura'),
                                    target: '_new',
                                },
                            }}
                            data-testid="informationBanner-msg"
                        />
                    ),
                    closable: false,
                },
            ])
        }
    })

    return (
        <PageLayoutContainer>
            <div className="grid">
                <div className="col-12 md:col-10 flex-order-1 md:flex-order-0">
                    {/* Information banner */}
                    <Messages ref={msgs} />

                    <Card>
                        <LazyTabView>
                            <TabPanel leftIcon="pi pi-bell mr-2" header={<Text code="lblAlarms" />}>
                                <DashboardAlarmsWidget />
                            </TabPanel>
                            <TabPanel header={<Text code="lblLatestErrorsWidget" />} leftIcon="pi pi-info-circle mr-2">
                                <LatestErrorWidget />
                            </TabPanel>
                        </LazyTabView>
                    </Card>
                </div>
                <div className="col-12 md:col-2 flex-order-0 md:flex-order-1 stats-widget">
                    <ChargePointStatusDashboardWidget chargePointStatusStats={statusStats} />
                    {favourites?.length ? <ChargePointFavoritesDashboardWidget favourites={favourites} /> : null}
                </div>
            </div>
        </PageLayoutContainer>
    )
}

export default DashboardPage
